/**
 * Group API Service
 * Handles all group-related API calls
 */

import axiosClient from '../../../api/axiosClient';
import { Group, CreateGroupDTO, UpdateGroupDTO } from '../model/types';

export const groupService = {
  /**
   * Get all groups for a specific board
   */
  getGroupsForBoard: async (boardId: number): Promise<Group[]> => {
    const response = await axiosClient.get(`/boards/${boardId}/groups`);
    return response.data;
  },

  /**
   * Get a specific group by ID
   */
  getGroup: async (groupId: number): Promise<Group> => {
    const response = await axiosClient.get(`/groups/${groupId}`);
    return response.data;
  },

  /**
   * Create a new group
   */
  createGroup: async (groupData: CreateGroupDTO): Promise<Group> => {
    const response = await axiosClient.post('/groups', groupData);
    return response.data;
  },

  /**
   * Update an existing group
   */
  updateGroup: async (groupId: number, updates: UpdateGroupDTO): Promise<Group> => {
    const response = await axiosClient.put(`/groups/${groupId}`, updates);
    return response.data;
  },

  /**
   * Delete a group
   */
  deleteGroup: async (groupId: number): Promise<void> => {
    await axiosClient.delete(`/groups/${groupId}`);
  },

  /**
   * Reorder groups on a board
   */
  reorderGroups: async (boardId: number, groupIds: number[]): Promise<Group[]> => {
    const response = await axiosClient.put(`/boards/${boardId}/groups/reorder`, {
      groupIds,
    });
    return response.data;
  },

  /**
   * Toggle group collapse state
   */
  toggleCollapse: async (groupId: number): Promise<Group> => {
    const response = await axiosClient.patch(`/groups/${groupId}/toggle-collapse`);
    return response.data;
  },
};

export default groupService;
